import qs from 'qs'
export function delObjNull(params) {
	for (let item in params) {
		if (typeof (params[item]) === 'undefined' || params[item] === null || params[item] === '') {
			delete params[item]
		}
	}
	return params
}

export function getUrlParams(str) {
	let urlStr = remove_arg_from_url(str)
	let result = qs.parse(urlStr)
	return result
}

// 删除apptoken
// eslint-disable-next-line camelcase
function remove_arg_from_url(name) {
	var loca = window.location
	var query = loca.search.substring(1)
	var obj = {}
	var arr = query.split('&')
	for (var i = 0; i < arr.length; i++) {
		arr[i] = arr[i].split('=')
		// 'undefined' 有的字段传过来变成了undefined字符串
		if (arr[i][1] && arr[i][1] !== 'undefined') {
			obj[arr[i][0]] = arr[i][1]
		}
	};
	if (query.indexOf(name) > -1) {
		delete obj[name]
	}
	// eslint-disable-next-line no-useless-escape
	var url = JSON.stringify(obj).replace(/[\"\{\}]/g, '').replace(/\:/g, '=').replace(/\,/g, '&')
	return url
}



// WEBPACK FOOTER //
// ./src/utils/filterObjNull.js